var _defs, _g, _g2, _rect, _rect2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g5, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _path25, _path26, _ellipse2, _ellipse3, _path27, _path28, _line, _g6, _g7, _path29, _path30, _path31, _path32, _g8, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g9, _g10, _path49, _path50, _circle, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _ellipse4, _path67, _path68, _rect3, _path69, _path70, _g11, _path71, _g12, _rect4, _rect5, _rect6, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g13, _path79, _rect7, _path80, _path81, _path82, _path83, _path84, _path85, _g14, _rect8, _ellipse5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2323.571,
    height: 1318.385,
    viewBox: "0 0 2323.571 1318.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 668.515,
    height: 537.468,
    transform: "translate(668.515 537.468) rotate(180)",
    fill: "#00b488"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.261,
    y1: 0.091,
    x2: 1.318,
    y2: 0.799,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f85254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f79865",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.018,
    y1: 0.647,
    x2: -0.219,
    y2: 0.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6663b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#372bcd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ErrorIllustration",
    transform: "translate(-10518.049 -2711.89)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10050",
    "data-name": "Group 10050",
    transform: "translate(10518.049 2711.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17590",
    "data-name": "Path 17590",
    d: "M2331.844,918.643c-82.2-135.407-229.171-225.9-397.386-225.9-45.533,0-89.342,7.3-131.2,19.2-99.791-161.525-276.482-269.4-478.6-269.4-274.606,0-503.65,199.153-554.379,462.858-8.2-.551-16.264-1.532-24.709-1.532-233.129,0-422.214,192-422.214,428.412,0,236.7,189.086,428.647,422.214,428.647H2224.506c233.311,0,422.424-191.946,422.424-428.647C2646.93,1133.428,2513.275,966.6,2331.844,918.643Z",
    transform: "translate(-323.358 -442.549)",
    fill: "#eceff8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10054",
    "data-name": "Group 10054",
    transform: "translate(11956.891 3485.673)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10053",
    "data-name": "Group 10053",
    transform: "translate(155.541 77.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17592",
    "data-name": "Path 17592",
    d: "M3541.558,2101.957c8.172-3.1,13.344-16.66-2.187-32.977-15.56-16.308-47.284-77.73-47.284-77.73-9.834,3.728-66.706-15.29-76.944-20.112-10.256-4.781-12.485,73.345-23.165,77.394-10.651,4.037,8.089-72.614,2.642-86.985s-36.45-17.09-57.754-9.015,1.519,167.17-8.316,170.9-22.469-163.1-31.57-167.381c-9.129-4.275-31.827-7.274-68.894,13.544-37.1,20.828,50.019,183.915,41.545,203.563s-68.838-181.616-70.761-186.688-45.94,27.081-56.44,51.332c-10.488,24.279,81.766,178.65,74.287,195.987s-82-149.589-88.717-167.314c-6.729-17.752-22.925-13.548-45.388,60.68-6.227,20.472-1.778,38.67,7.724,54.47-57.671,58.116-.179,167.879,41.842,187.595a68.36,68.36,0,0,0,22.868,6.253,69.435,69.435,0,0,0,20.625-1.275,76.61,76.61,0,0,0,12.311-3.571c-.779,1.005-1.541,1.97-2.292,2.964l17.163-1.06-2.124,20.754c1.322,8.587,4.1,19.233,9.109,32.449,23.381,61.685,185.019,23.719,153.236,8.823-31.754-14.906-84.9-78.168-72.613-82.825s61.9,64.423,100.76,68.063,61.05-54.046,61.05-54.046-133.086-40.857-126.861-55.3c6.251-14.456,135.642,58.741,164.049,59.543,28.445.819,54.93-65.263,54.93-65.263s-205.119-29.475-206.445-47.342c-1.315-17.839,195.228,40.024,216.1,23.412s22.783-73.382,22.783-73.382-194.764,5.242-193.673-11.607c1.129-16.832,168.215,8.721,186.282-2.962s-13.866-66.258-17.7-76.374c-3.845-10.145-115.548,15.275-129.771,8.613C3407.7,2118.4,3533.358,2105.065,3541.558,2101.957ZM3172.442,2255.4c-4.237,9.824-56.407-15.327-61.293-40.546a64.761,64.761,0,0,0-3.267-11.17C3136.056,2232.1,3174.936,2249.654,3172.442,2255.4Z",
    transform: "translate(-3065.996 -1948.044)",
    fill: "#00b488"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 186.978,
    height: 26.698,
    transform: "translate(12086.492 3225.822)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 254.05,
    height: 8.391,
    transform: "translate(12086.492 3259.843)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10089",
    "data-name": "Group 10089",
    transform: "translate(10610.176 3708.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M3266.911,1982.4c14.983,10.43,37.424,23.831,64.867,39.459a.014.014,0,0,1,.017.012c20.87,11.874,44.6,25,70.084,39.081,23.388,12.9,48.247,26.594,73.719,40.788l99.659-15.693,3.268,2.974,2.957-3.954,48.158-7.583,2.19-27.866q-6.54-7.14-13.22-14.2l0-.015c-.766-.782-1.479-1.526-2.215-2.313-1.634-1.731-3.264-3.433-4.9-5.15l-2.91-3.03,0-.029c-2.452-2.552-4.9-5.073-7.345-7.594-.325-.316-.635-.634-.948-.968l0-.015q-8.176-8.351-16.428-16.6c-38.258-38.172-78.079-74.109-117.289-105.109-.017-.013-.02-.028-.037-.041q-7.941-6.276-15.858-12.3c-.018-.013-.034-.025-.021-.042-34.541-26.213-68.3-48.312-99.839-64.441a309.748,309.748,0,0,0-39.868-17.205c-.744-.25-1.457-.5-2.183-.743C3164.46,1751.173,3119.553,1879.558,3266.911,1982.4Z",
    transform: "translate(-3176.082 -1789.201)",
    fill: "#1b7154",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M3306.05,1957.734c.484.26,69.39,33.407,157.757,89.986,1.176.763,2.352,1.527,3.542,2.288,31.083,20,64.451,42.844,98.037,68.152q16.247,12.242,32.49,25.235,16.62,13.308,33.011,27.387,7.323,6.282,14.549,12.731c.195.168.392.352.586.52,1.333,1.182,2.665,2.349,3.985,3.549l3.268,2.973,2.958-3.953,3.209-.505c-.539-.512-1.109-1.019-1.663-1.528l-.018-.013q-3.83-3.481-7.7-6.941l-.017-.012c-.212-.181-.41-.365-.606-.548-3.912-3.469-7.866-6.915-11.8-10.32-1.294-1.127-2.618-2.249-3.913-3.377l-.034-.025q-12.833-10.967-25.83-21.51-14.677-11.893-29.431-23.208c-41.667-31.929-83.282-60.134-120.91-83.9-1.139-.723-2.277-1.447-3.414-2.155-82.343-51.744-144.715-81.775-145.193-81.99a3.538,3.538,0,0,0-4.9,1.9A4.205,4.205,0,0,0,3306.05,1957.734Z",
    transform: "translate(-3250.833 -1890.74)",
    fill: "#0e2d34",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10090",
    "data-name": "Group 10090",
    transform: "translate(10742.441 3444.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M3099.27,1288.246q2.629,12.65,5.992,25.815c11.206,43.886,28.221,91.59,49.328,140.569,2.34,5.47,4.763,10.977,7.223,16.492,11.288,25.311,23.622,50.879,36.737,76.374q5.906,11.495,12.031,22.952,4.295,8.04,8.673,16.033c3.1,5.69,11.82,23.98,22.5,46.621q1.2,2.533,2.423,5.14c2.019,4.295,4.1,8.709,6.213,13.215,2.7,5.718,5.441,11.573,8.2,17.437h162.475c.652-1.863,1.276-3.744,1.882-5.626-2.377-9.517-4.993-19.612-7.811-30.166-36.792-138.2-107.374-355.878-125.224-407.188C3216.794,1015.616,3052.7,1064.43,3099.27,1288.246Z",
    transform: "translate(-3091.084 -1091.641)",
    fill: "#8ccc6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M3303.084,1264.894c.119.615,33.295,125.756,82.614,272.722,17.456,52.008,36.939,106.741,57.68,159.658q4.047,10.325,8.159,20.539,2.065,5.121,4.139,10.215,2.244,5.52,4.506,10.976c.23.542.45,1.074.67,1.606.486,1.184.982,2.359,1.468,3.533q6.483,15.542,13.087,30.653h9.04q-6.609-15.074-13.133-30.653c-.716-1.7-1.422-3.4-2.138-5.121a.03.03,0,0,0-.009-.019q-3.552-8.562-7.066-17.235-4.419-10.875-8.765-21.888c-19.079-48.365-37.14-98.482-53.586-146.764-52.448-154-88.432-289.379-88.552-290.021a4.141,4.141,0,0,0-4.874-3.46A4.475,4.475,0,0,0,3303.084,1264.894Z",
    transform: "translate(-3230.833 -1197.542)",
    fill: "#5f9850",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10057",
    "data-name": "Group 10057",
    transform: "translate(11842.629 2858.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17593",
    "data-name": "Path 17593",
    d: "M3480.508,871.669H2834.074a21.251,21.251,0,0,0-21.251,21.251v397.635a41.523,41.523,0,0,0,41.524,41.522h605.89a41.523,41.523,0,0,0,41.523-41.522V892.92A21.251,21.251,0,0,0,3480.508,871.669Z",
    transform: "translate(-2798.662 -857.508)",
    fill: "#c9c9c9",
    fillRule: "evenodd",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17594",
    "data-name": "Path 17594",
    d: "M2812.813,850.408h646.435a21.25,21.25,0,0,1,21.25,21.251v38.758H2791.562V871.659A21.251,21.251,0,0,1,2812.813,850.408Z",
    transform: "translate(-2791.562 -850.408)",
    fill: "#4332d5",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17595",
    "data-name": "Path 17595",
    d: "M2791.562,940.5H3480.5v358.878a41.522,41.522,0,0,1-41.522,41.522h-605.89a41.523,41.523,0,0,1-41.523-41.522Z",
    transform: "translate(-2791.562 -880.496)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17598",
    "data-name": "Path 17598",
    d: "M3603.676,878.363a17.125,17.125,0,1,1,29.659,17.129,17.125,17.125,0,0,1-29.659-17.129Z",
    transform: "translate(-3062.001 -856.866)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17599",
    "data-name": "Path 17599",
    d: "M3738.276,878.363a17.125,17.125,0,1,1,29.659,17.129,17.216,17.216,0,0,1-23.451,6.208,16.982,16.982,0,0,1-6.208-23.336Z",
    transform: "translate(-3106.934 -856.866)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17600",
    "data-name": "Path 17600",
    d: "M3670.989,878.363a17.125,17.125,0,1,1,29.659,17.129,17.125,17.125,0,0,1-29.659-17.129Z",
    transform: "translate(-3084.481 -856.866)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17601",
    "data-name": "Path 17601",
    d: "M3193.715,1180.343v-15.289l80.93-37.247v16.439l-64.147,28.51,64.147,28.97v16.323Zm90.587,60.468,35.636-137.721h12.186l-35.752,137.721Zm138.179-60.468-80.931,37.706v-16.323l63.918-28.97-63.918-28.51v-16.439l80.931,37.247Z",
    transform: "translate(-2925.862 -934.792)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17602",
    "data-name": "Path 17602",
    d: "M2913.47,1505.6s11.181,38.553-7.081,83.195l125.807-79.136Z",
    transform: "translate(-2829.909 -1069.21)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17656",
    "data-name": "Path 17656",
    d: "M1636.749,2064.305l31.4,238.378H1485.443l-7.137-191.273Z",
    transform: "translate(9694.544 1567.994)",
    fill: "#d9365c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17657",
    "data-name": "Path 17657",
    d: "M1255.274,1882.859s-97.54,39.967-110.386,191.273,7.137,305.467,7.137,305.467h195.556l29.975-361.612S1337.113,1870.011,1255.274,1882.859Z",
    transform: "translate(9832.406 1642.385)",
    fill: "#ff4f78"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17658",
    "data-name": "Path 17658",
    d: "M1611.6,1034.64s-27.121-42.822-87.072-14.274c-58.394,27.807-104.2,296.9-154.161,342.58s-71.371,71.371-49.96,101.346-9.992,18.557-8.564,44.25,25.694,28.549,25.694,28.549l174.145-219.822Z",
    transform: "translate(9762.515 1998.145)",
    fill: "#121f33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17659",
    "data-name": "Path 17659",
    d: "M1274.009,1909.639s12.417,54.242,82.361,62.806l-8.564-57.1-45.677-27.121S1283,1901.074,1274.009,1909.639Z",
    transform: "translate(9777.939 1639.87)",
    fill: "#d9365c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17660",
    "data-name": "Path 17660",
    d: "M1381.046,1647.7l-20.717,52.337s-51.387,32.831-48.532,45.677,5,21.321,5,21.321,22.125,34.348,46.391,41.485,29.976-78.508,29.976-78.508l1.427-138.459-4.079,22.838A173.252,173.252,0,0,1,1381.046,1647.7Z",
    transform: "translate(9762.561 1760.977)",
    fill: "#3b2bc9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17661",
    "data-name": "Path 17661",
    d: "M1250.37,2056.988s72.8-9.992,107.056-92.782",
    transform: "translate(9787.589 1608.855)",
    fill: "none",
    stroke: "#d9365c",
    strokeMiterlimit: 10,
    strokeWidth: 7.236
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17662",
    "data-name": "Path 17662",
    d: "M1686.813,1041.717s-57.1-32.83-77.08,18.557-15.7,121.33-54.242,165.58",
    transform: "translate(9663.036 1989.641)",
    fill: "none",
    stroke: "#2a4368",
    strokeMiterlimit: 10,
    strokeWidth: 2.412
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17663",
    "data-name": "Path 17663",
    d: "M1891.739,1579.792H1691.9c-12.847,18.556-77.794,144.169-77.794,144.169L1526.321,1835.3l-79.935,12.847s-39.968-8.565-59.951-39.968,45.677-244.088,35.686-331.161,0-111.338,37.112-126.754,87.073,15.416,87.073,15.416,128.467,9.992,154.161,14.274c10.72,1.784,26.664,21.469,43.065,45.777,22.882,33.944,46.634,76.881,58.281,92.682C1821.8,1545.534,1891.739,1579.792,1891.739,1579.792Z",
    transform: "translate(9733.601 1861.234)",
    fill: "#5846f5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17664",
    "data-name": "Path 17664",
    d: "M1768.042,1460.1s74.444-1.854,112.19-47.465l-26.737-34.6-59.764,39.319Z",
    transform: "translate(9576.271 1848.136)",
    fill: "#3b2bc9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17665",
    "data-name": "Path 17665",
    d: "M1747.4,1404.489l-2.692,16.154a30.107,30.107,0,0,1-35.269,24.667c-20.3-3.857-44.262-14.145-50.538-40.821-4.282-18.2-5.752-31.784-.953-39.393,6.663-10.566,12.373-21.986,12.373-21.986S1754.538,1344.537,1747.4,1404.489Z",
    transform: "translate(9622.433 1862.392)",
    fill: "#f4a07a"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10072",
    "data-name": "Group 10072",
    transform: "translate(11311.309 3069.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17666",
    "data-name": "Path 17666",
    d: "M1887.5,1188.193s-17.129,115.621-66.218,134.177a57.573,57.573,0,0,1-16.886,3.554c-30.361,1.77-64.876-14.931-77.666-59.224-15.26-52.814,10.677-122.758,10.677-122.758l83.875-29.975,2.512,1.656,43.237,28.32Z",
    transform: "translate(-1716.212 -1113.968)",
    fill: "#f9a880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17667",
    "data-name": "Path 17667",
    d: "M1883.562,1189.335a422.322,422.322,0,0,1-9.921,46.177,322.368,322.368,0,0,1-11.6,35.057c-10.363,25.879-24.937,45.477-44.693,52.943a57.573,57.573,0,0,1-16.886,3.554c-28.448-1.627-60.694-22.653-72.484-63.506-15.259-52.814-15.7-119.9-15.7-119.9l107.584-26.892,43.237,28.32Z",
    transform: "translate(-1712.272 -1115.11)",
    fill: "#ffba94"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17668",
    "data-name": "Path 17668",
    d: "M1810.6,1109.891a53.644,53.644,0,0,1-9.035-2.455s-17.129-12.847-24.266-2.855-27.121,71.371-95.637,71.371l-.5,1.342-13.774,37.2s-58.524-44.25-28.548-117.048,141.58-88.984,178.692-26.177C1844.242,1116.473,1823.421,1112.132,1810.6,1109.891Z",
    transform: "translate(9632.499 1991.01)",
    fill: "#1d3151"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17669",
    "data-name": "Path 17669",
    d: "M1981.373,1155.857c-1.927,8.536-10.863,14.916-21.611,15.573a211.416,211.416,0,0,1-36.442-1.014c-3-.342-5.724-.714-8.136-1.085-5.952-.913-9.663-5.738-7.965-10.405a83.312,83.312,0,0,0,3.027-11.22,123.731,123.731,0,0,0-.543-51.087l-6.081-27.949-.8-3.668s2.084-.471,5.567-.928c2.1-.257,4.7-.514,7.651-.643,16.472-.785,44.164,2.07,58.1,27.064C1987.454,1114.405,1984.87,1140.441,1981.373,1155.857Z",
    transform: "translate(9521.253 1976.604)",
    fill: "#1d3151"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17670",
    "data-name": "Path 17670",
    d: "M1304.593,1935.262s-66.375,56.383-74.939,160.585,0,305.467,0,305.467",
    transform: "translate(9797.6 1620.671)",
    fill: "none",
    stroke: "#d9365c",
    strokeMiterlimit: 10,
    strokeWidth: 7.236
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17671",
    "data-name": "Path 17671",
    d: "M1179.162,1988.259l13.077,7.473a3.323,3.323,0,0,1,1.326,4.379,331.763,331.763,0,0,0-28.786,89.723,16.274,16.274,0,0,1-22.1,12.448h0a2.7,2.7,0,0,1-1.69-2.821c1.343-11.691,9.04-70.65,31.523-109.422A4.885,4.885,0,0,1,1179.162,1988.259Z",
    transform: "translate(9832.246 1599.3)",
    fill: "#d9365c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17672",
    "data-name": "Path 17672",
    d: "M1827.69,1236.464c2.749.439,6.021-.477,9.23-1.209,3.218-.795,6.468-1.526,9.311-2.077s6.14-1.094,9.422-1.562c3.251-.522,6.645-.9,8.993-2.332,2.274-1.349,2.782-4.047-.711-6.566-3.3-2.47-11.045-4.35-20.477-2.538-9.413,1.849-15.773,6.468-17.8,9.974C1823.476,1233.776,1825.044,1236.07,1827.69,1236.464Z",
    transform: "translate(9553.173 1912.867)",
    fill: "#1d3151"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17673",
    "data-name": "Path 17673",
    d: "M1968.542,1244.369c1.147,1.093,2.965,1.385,4.695,1.787,1.754.361,3.5.777,5.006,1.2s3.214.986,4.9,1.595c1.684.562,3.39,1.263,4.937.933,1.487-.3,2.573-2.043,1.732-4.806-.766-2.674-3.8-6.2-8.774-7.625-4.982-1.391-9.407.032-11.458,1.91C1967.418,1241.281,1967.43,1243.337,1968.542,1244.369Z",
    transform: "translate(9494.728 1905.749)",
    fill: "#1d3151"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17674",
    "data-name": "Path 17674",
    d: "M1976.817,1317.422a322.334,322.334,0,0,1-11.6,35.057,45.994,45.994,0,0,1,1.756-17.157A44.253,44.253,0,0,1,1976.817,1317.422Z",
    transform: "translate(9495.861 1872.878)",
    fill: "#fca286"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 27.337,
    cy: 17.789,
    rx: 27.337,
    ry: 17.789,
    transform: "translate(11446.875 3207.745) rotate(-76.012)",
    fill: "none",
    stroke: "#1f267f",
    strokeMiterlimit: 10,
    strokeWidth: 4.824
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17675",
    "data-name": "Path 17675",
    d: "M1941.414,1328.638l4.283,12.847s5.1-4.743,2.022-9.635C1945.7,1328.638,1941.414,1328.638,1941.414,1328.638Z",
    transform: "translate(9505.499 1868.299)",
    fill: "#ffba94"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17676",
    "data-name": "Path 17676",
    d: "M1938.8,1334.362c-.12,0-.241,0-.363,0l-4.761-.2a1.067,1.067,0,0,1-.9-1.163c.011-.621.452-1.151.934-1.09l4.76.2a4.394,4.394,0,0,0,3.728-2.189,10.67,10.67,0,0,0,1.716-5.877l.011-.665c.028-1.761-.819-3.231-1.89-3.277a5.266,5.266,0,0,1-4.139-2.762,11.091,11.091,0,0,1-1.545-6.028l.2-9.5a1.041,1.041,0,0,1,.939-1.083,1.072,1.072,0,0,1,.894,1.169l-.2,9.493a8.441,8.441,0,0,0,1.159,4.584,3.515,3.515,0,0,0,2.73,1.873c2.081.088,3.734,2.6,3.685,5.6l-.011.666a13.224,13.224,0,0,1-2.149,7.282A6.188,6.188,0,0,1,1938.8,1334.362Z",
    transform: "translate(9509.026 1879.693)",
    fill: "#ff806d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 29.262,
    cy: 32.117,
    rx: 29.262,
    ry: 32.117,
    transform: "matrix(0.98, -0.199, 0.199, 0.98, 11332.614, 3172.013)",
    fill: "#fca286"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 30.923,
    cy: 28.21,
    rx: 30.923,
    ry: 28.21,
    transform: "matrix(0.176, -0.984, 0.984, 0.176, 11372.588, 3204.041)",
    fill: "none",
    stroke: "#1f267f",
    strokeMiterlimit: 10,
    strokeWidth: 4.824
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17677",
    "data-name": "Path 17677",
    d: "M1919.706,1303.233s15.75-5.708,18.581,2.856",
    transform: "translate(9514.361 1879.431)",
    fill: "none",
    stroke: "#1f267f",
    strokeMiterlimit: 10,
    strokeWidth: 4.824
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17678",
    "data-name": "Path 17678",
    d: "M1889.895,1397.384c2.017-4.78-1.956-12.33-9.31-16.652-4.258-2.5-7.908-1.095-10.674,1.75a77.8,77.8,0,0,0-8.594,10.461c-2.625,4.1-1.576,13.475,9.843,13.475S1887.878,1402.164,1889.895,1397.384Z",
    transform: "translate(13283.481 4643.004) rotate(180)",
    fill: "#ff806d"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 57.097,
    y1: 4.282,
    transform: "translate(11321.301 3165.534)",
    fill: "none",
    stroke: "#1f267f",
    strokeMiterlimit: 10,
    strokeWidth: 4.824
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10073",
    "data-name": "Group 10073",
    transform: "translate(11402.664 3171.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17679",
    "data-name": "Path 17679",
    d: "M1880.9,1294.148c-.531,4.148-3.626,7.171-6.914,6.75s-5.524-4.125-4.994-8.274,3.626-7.172,6.915-6.751S1881.436,1290,1880.9,1294.148Z",
    transform: "translate(-1867.571 -1285.472)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17680",
    "data-name": "Path 17680",
    d: "M1870.924,1289.5a10.658,10.658,0,0,1-4.282-4.282,21.834,21.834,0,0,0,1.8,5.46C1869.5,1292.359,1870.924,1289.5,1870.924,1289.5Z",
    transform: "translate(-1866.642 -1285.222)",
    fill: "#1d3151"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10074",
    "data-name": "Group 10074",
    transform: "translate(11459.506 3178.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17681",
    "data-name": "Path 17681",
    d: "M1962.913,1303.079c-.812,3.87.692,7.608,3.362,8.349s5.493-1.8,6.306-5.668-.692-7.609-3.361-8.348S1963.726,1299.207,1962.913,1303.079Z",
    transform: "translate(-1962.693 -1297.283)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17682",
    "data-name": "Path 17682",
    d: "M1977.095,1304.03a8.248,8.248,0,0,0,4.578-2.358,20.593,20.593,0,0,1-3,4.246C1977.358,1307.053,1977.095,1304.03,1977.095,1304.03Z",
    transform: "translate(-1968.572 -1299.075)",
    fill: "#1d3151"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17683",
    "data-name": "Path 17683",
    d: "M1727.643,1182.063s-27.518-51.46-5.957-90.755C1721.686,1091.308,1706.329,1138.337,1727.643,1182.063Z",
    transform: "translate(9598.562 1965.18)",
    fill: "#2a4368"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17684",
    "data-name": "Path 17684",
    d: "M1776.922,1160.284s-41.189-41.338-31.877-85.181C1745.046,1075.1,1743.9,1124.563,1776.922,1160.284Z",
    transform: "translate(9586.218 1971.795)",
    fill: "#2a4368"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17685",
    "data-name": "Path 17685",
    d: "M1843.855,1148.736a53.671,53.671,0,0,1-9.035-2.455s-17.129-12.847-24.266-2.855-27.121,71.371-95.637,71.371l-.5,1.342c-5.082-2.156-3.554-3.8,10.491-4.2,49.96-1.427,68.517-67.088,85.646-82.79s30.989,4.582,30.989,4.582Z",
    transform: "translate(9599.247 1952.164)",
    fill: "#121f33"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17686",
    "data-name": "Path 17686",
    d: "M1925.66,1165.066c-.756,1.528-1.542,2.969-2.341,4.325-3-.342-5.724-.714-8.136-1.085-5.952-.913-9.663-5.738-7.965-10.406a83.3,83.3,0,0,0,3.027-11.22,123.729,123.729,0,0,0-.543-51.087l-6.88-31.875c1.7-1.9,4.1.471,5.567-.67,3.3-2.555,5.924-3.083,7.565-.757,0,0,.028.043.085.114C1918.081,1064.9,1953.4,1109.6,1925.66,1165.066Z",
    transform: "translate(9521.253 1977.63)",
    fill: "#121f33"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10075",
    "data-name": "Group 10075",
    transform: "translate(11278.479 3147.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17687",
    "data-name": "Path 17687",
    d: "M1701.56,1261.307s-8.969-22.8-29.836-14.255-18.465,44.009-1.407,59.978,33.26-2.813,33.26-2.813Z",
    transform: "translate(-1656.795 -1245.138)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17688",
    "data-name": "Path 17688",
    d: "M1692.075,1306.681a2.644,2.644,0,0,0,1.821-.835l10.991-11.5-15.949-17.886a2.627,2.627,0,0,0-3.92-.092,3.163,3.163,0,0,0-.063,4.231l12.1,13.574-7.031,7.358a3.159,3.159,0,0,0-.052,4.231A2.671,2.671,0,0,0,1692.075,1306.681Z",
    transform: "translate(-1667.972 -1257.548)",
    fill: "#ff806d"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17689",
    "data-name": "Path 17689",
    d: "M1618.383,1676.806l-8.912-48.462,23.963,48.462Z",
    transform: "translate(9641.002 1745.957)",
    fill: "#3b2bc9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17690",
    "data-name": "Path 17690",
    d: "M1615.761,1508.255s14.155,31.456-6.291,70.774l7.865,24.524s9.436,2.213,15.728-24.524l-11.8,5.767S1634.634,1552.293,1615.761,1508.255Z",
    transform: "translate(9641.002 1794.979)",
    fill: "#3b2bc9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17691",
    "data-name": "Path 17691",
    d: "M1896.493,1598.614s11.01,51.9,4.718,66.056h17.3S1909.075,1619.06,1896.493,1598.614Z",
    transform: "translate(9523.836 1758.093)",
    fill: "#3b2bc9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17692",
    "data-name": "Path 17692",
    d: "M2344.172,1627.848v92.007l-57.405,57.406H2066.581v-80.321a67.517,67.517,0,0,1,67.519-67.518h124.358Z",
    transform: "translate(9454.404 1746.159)",
    fill: "#441e8c",
    fillRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17693",
    "data-name": "Path 17693",
    d: "M2365.87,1631.489v89.852l-57.405,57.406H2119.734V1700a67.518,67.518,0,0,1,67.518-67.519H2311.61Z",
    transform: "translate(9432.707 1744.673)",
    fill: "#592ba3",
    fillRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17694",
    "data-name": "Path 17694",
    d: "M2492.53,1899.537v181.282c-28.833-8.351-54.442-23.952-72.1-36.742a269.246,269.246,0,0,1-23.153-18.671c-1.042-.942-1.641-1.527-1.784-1.656l-.028-.028s-1.441,4.068-3.711,10.92c-3.3,9.906-8.365,25.622-13.418,43.322a113.751,113.751,0,0,0-2.855,47.1h-298.33c-115.621-39.968-107.056-182.71-45.677-272.637,62.292-91.269,168.435-111.338,168.435-111.338l19.984,4.282,142.742,14.274s42.823,27.121,61.379,45.678S2492.53,1899.537,2492.53,1899.537Z",
    transform: "translate(9486.81 1699.932)",
    fill: "#53ddde"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17695",
    "data-name": "Path 17695",
    d: "M2431.94,1644.613l-5.709,58.524s7.137,52.814,42.822,54.242,48.532-9.992,54.242-17.129l5.709-68.516Z",
    transform: "translate(9307.593 1739.316)",
    fill: "#f9a880"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17696",
    "data-name": "Path 17696",
    d: "M2616.676,1388.939l19.781,58.524-37.416-30.884Z",
    transform: "translate(9237.051 1843.684)",
    fill: "#af872a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17697",
    "data-name": "Path 17697",
    d: "M2329.617,1472.88s-34.195-2.591-31.34,30.24,55.669,58.524,55.669,58.524l8.564-11.419Z",
    transform: "translate(9359.895 1809.439)",
    fill: "#af872a"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17698",
    "data-name": "Path 17698",
    d: "M2580.731,1733.858s1.427,34.258-20.793,55.418c0,0,17.047,18.3,27.9,32.892a7.3,7.3,0,0,0,12.191-.693c6.138-10.785,9.531-40.156,4.971-64.779Z",
    transform: "translate(9253.013 1702.885)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17699",
    "data-name": "Path 17699",
    d: "M2576.86,1549.334c-10.19,50.95-101.346,84.218-161.3-12.847-52.512-85.02-28.548-149.878,22.839-155.588s85.645,11.419,85.645,11.419,13.446,23.738,26.093,52.771c6.5,14.931,12.79,31.261,16.929,46.477C2571.936,1509.4,2581.142,1527.923,2576.86,1549.334Z",
    transform: "translate(9323.972 1847.442)",
    fill: "#ffba94"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17700",
    "data-name": "Path 17700",
    d: "M2402.7,1588.962s-16.423-15.89-31.205,0,1.642,45.9,22.994,52.967,27.921-15.89,27.921-15.89Z",
    transform: "translate(9332.251 1764.916)",
    fill: "#ffba94"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17701",
    "data-name": "Path 17701",
    d: "M2384.688,1496.906s-17.128-51.387-9.992-51.387,141.314-31.4,129.895-74.225-55.669-25.694-55.669-25.694S2284.769,1382.713,2384.688,1496.906Z",
    transform: "translate(9337.717 1862.756)",
    fill: "#af872a"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17702",
    "data-name": "Path 17702",
    d: "M2329.886,1394.038s-25.693-47.1,22.839-69.944,38.54-17.129,55.669-45.677,64.234-25.694,75.653,0-4.282,51.387-4.282,51.387Z",
    transform: "translate(9349.695 1897.109)",
    fill: "#af872a"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17703",
    "data-name": "Path 17703",
    d: "M2563.717,1333.349s38.953-29.275,48.532.528c12.847,39.968-48.532,66.881-48.532,66.881Z",
    transform: "translate(9251.471 1871.624)",
    fill: "#af872a"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17704",
    "data-name": "Path 17704",
    d: "M2620.742,1572.367c-.2.094-.406.185-.616.269l-8.166,3.273a1.693,1.693,0,0,1-1.262-3.143l8.166-3.273a8.755,8.755,0,0,0,5.019-5.8,14.137,14.137,0,0,0-.549-9.407l-.372-.929c-.987-2.457-3.283-3.86-5.12-3.126a9.921,9.921,0,0,1-8.621-.739,14.172,14.172,0,0,1-6.151-7.189l-5.244-13.289a1.759,1.759,0,0,1,.953-2.2,1.7,1.7,0,0,1,2.2.953l5.239,13.28a10.779,10.779,0,0,0,4.651,5.479,6.585,6.585,0,0,0,5.716.559c3.572-1.429,7.843.818,9.522,5.007l.372.928a17.544,17.544,0,0,1,.642,11.675A12.229,12.229,0,0,1,2620.742,1572.367Z",
    transform: "translate(9237.59 1787.452)",
    fill: "#ff806d"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10078",
    "data-name": "Group 10078",
    transform: "translate(11760.349 3287.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17705",
    "data-name": "Path 17705",
    d: "M2475.459,1508.809c2.651-.621,5.238-2.69,7.841-4.566,2.586-1.938,5.226-3.828,7.571-5.4s5.1-3.306,7.875-4.964c2.724-1.7,5.632-3.318,7.184-5.517,1.517-2.1.908-4.784-3.238-5.809-3.953-1.052-11.677.1-19.461,5.3-7.753,5.227-11.658,11.876-12.1,15.878C2470.6,1507.9,2472.918,1509.433,2475.459,1508.809Z",
    transform: "translate(-2471.052 -1482.199)",
    fill: "#7f5f16"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10079",
    "data-name": "Group 10079",
    transform: "translate(11832.353 3281.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17706",
    "data-name": "Path 17706",
    d: "M2595.026,1483.419c2.186.436,4.861-.136,7.476-.571,2.626-.483,5.274-.915,7.586-1.226s4.988-.6,7.648-.832c2.639-.275,5.384-.436,7.343-1.431,1.9-.937,2.443-2.963-.235-5-2.525-2-8.649-3.71-16.319-2.689-7.656,1.049-13,4.313-14.811,6.893C2591.779,1481.224,2592.922,1483.022,2595.026,1483.419Z",
    transform: "translate(-2592.722 -1471.364)",
    fill: "#7f5f16"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17707",
    "data-name": "Path 17707",
    d: "M2538.761,1549.349c1.674,4.357.254,8.956-3.172,10.272s-7.561-1.149-9.235-5.505-.255-8.958,3.171-10.273S2537.087,1544.991,2538.761,1549.349Z",
    transform: "translate(9267.009 1780.596)",
    fill: "#1d3151"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17708",
    "data-name": "Path 17708",
    d: "M2632,1515.212c1.348,4.468-.405,8.95-3.918,10.012s-7.456-1.7-8.8-6.17.4-8.951,3.918-10.011S2630.648,1510.742,2632,1515.212Z",
    transform: "translate(9228.977 1794.75)",
    fill: "#1d3151"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 29.262,
    cy: 29.262,
    r: 29.262,
    transform: "translate(11740.961 3333.969)",
    fill: "#fca286"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17709",
    "data-name": "Path 17709",
    d: "M2676,1536.648a29.253,29.253,0,0,1-16.93-46.477C2665.566,1505.1,2671.86,1521.432,2676,1536.648Z",
    transform: "translate(9215.04 1802.36)",
    fill: "#fca286"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17710",
    "data-name": "Path 17710",
    d: "M2393.184,1493.168s-12.587,31.648,9.408,74.348l-29.344-47.01,2.25-44.079Z",
    transform: "translate(9329.221 1807.971)",
    fill: "#af872a"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17711",
    "data-name": "Path 17711",
    d: "M2507.156,1796.571l-8.564,22.838,15.449,59.866a5.937,5.937,0,0,0,11.625-.633l11.466-79.217Z",
    transform: "translate(9278.055 1677.285)",
    fill: "#f9a880"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17712",
    "data-name": "Path 17712",
    d: "M2401.994,1725.431c5.875,16.114,17.436,40.632,36.537,53.365a59.6,59.6,0,0,1-33.154,27.033,22.659,22.659,0,0,1-25.875-9.417c-8.825-13.663-21.79-38.441-28.044-73.286,0,0,8.564-18.556,46.93-26.047h0A64.461,64.461,0,0,0,2401.994,1725.431Z",
    transform: "translate(9338.115 1717.898)",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17713",
    "data-name": "Path 17713",
    d: "M2778.97,2152.649v55.184c-53.4-15.459-95.723-55.812-97.036-57.068l-.029-.029,29.976-98.492C2733.935,2098.179,2754.062,2124.515,2778.97,2152.649Z",
    transform: "translate(9203.225 1572.917)",
    fill: "#2bb9ba",
    opacity: 0.6
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17714",
    "data-name": "Path 17714",
    d: "M2404.15,1647.461a1.974,1.974,0,0,0,.972-1.136l3.844-11.224-16.4-7.119a1.96,1.96,0,0,0-2.683,1.165,2.359,2.359,0,0,0,1.281,2.885l12.445,5.4-2.457,7.184a2.356,2.356,0,0,0,1.289,2.881A2,2,0,0,0,2404.15,1647.461Z",
    transform: "translate(9322.479 1746.177)",
    fill: "#ff806d"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17715",
    "data-name": "Path 17715",
    d: "M2095.784,2212.586s28.548-27.121,82.922-14.274c67.473,15.942,109.779,62.806,109.779,72.8,0,0,9.175-9.035-8.564-31.4C2247.09,2198.312,2124.332,2158.344,2095.784,2212.586Z",
    transform: "translate(9442.484 1518.205)",
    fill: "#2bb9ba"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17716",
    "data-name": "Path 17716",
    d: "M2263.489,1880.992s7.137,32.831,0,68.516c-8.016,40.081-41.4,92.782-41.4,92.782l-5.709-23.552S2259.208,1965.209,2263.489,1880.992Z",
    transform: "translate(9393.254 1642.824)",
    fill: "#2bb9ba"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17717",
    "data-name": "Path 17717",
    d: "M2552.54,2237.127c-3.3,9.906-8.365,25.622-13.418,43.322a113.745,113.745,0,0,0-2.854,47.1H2381.078C2486.835,2312.666,2533.283,2266.417,2552.54,2237.127Z",
    transform: "translate(9326.025 1497.447)",
    fill: "#2bb9ba",
    opacity: 0.6
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17718",
    "data-name": "Path 17718",
    d: "M2703.3,2229.183a269.287,269.287,0,0,1-23.153-18.67c5.267-9.692,6.952-15.958,6.952-15.958Z",
    transform: "translate(9203.943 1514.825)",
    fill: "url(#linear-gradient)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17719",
    "data-name": "Path 17719",
    d: "M2626.794,1659.521c-2.407,1.3-9.632-1.536-18.009-2.447-8.8-.955-18.815-.192-21.311-2.272-4.718-3.932,6.2-11.009,20.446-11.009C2625.222,1643.794,2631.906,1656.769,2626.794,1659.521Z",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 8776.096, 3103.285)",
    fill: "#ff806d"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17720",
    "data-name": "Path 17720",
    d: "M2767.16,2371.9h-38.983a5.264,5.264,0,0,1-5.267-5.268v-10.149a4.91,4.91,0,0,1,.172-1.3,5.24,5.24,0,0,1,4.354-3.911l38.9-5.51.114,3.654Z",
    transform: "translate(9186.486 1453.1)",
    fill: "#229"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17721",
    "data-name": "Path 17721",
    d: "M2766.565,2349.418l-.714,1.071-42.651,4.7a5.241,5.241,0,0,1,4.353-3.911l38.9-5.51Z",
    transform: "translate(9186.367 1453.1)",
    fill: "#2e2eaa"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17722",
    "data-name": "Path 17722",
    d: "M2818.65,1943.13l-23.379,239.3h341.153l29.975-248.371H2828.654A10.051,10.051,0,0,0,2818.65,1943.13Z",
    transform: "translate(9156.947 1621.163)",
    fill: "#4332d5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17723",
    "data-name": "Path 17723",
    d: "M3189.434,1943.006l-28.89,239.421H2819.391l24.266-248.371h337.855A7.986,7.986,0,0,1,3189.434,1943.006Z",
    transform: "translate(9147.102 1621.163)",
    fill: "#7464ff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17724",
    "data-name": "Path 17724",
    d: "M3211.529,1943.006l-28.891,239.421H2873.517c210.643-58.51,273.864-210.644,286.525-248.371h43.564A7.986,7.986,0,0,1,3211.529,1943.006Z",
    transform: "translate(9125.007 1621.163)",
    fill: "#4332d5",
    opacity: 0.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 31.914,
    cy: 24.587,
    rx: 31.914,
    ry: 24.587,
    transform: "translate(12140.283 3706.917) rotate(-83.792)",
    fill: "#fff",
    opacity: 0.7
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17725",
    "data-name": "Path 17725",
    d: "M3153.453,2357.217v4.282a10.71,10.71,0,0,1-10.706,10.706H2798.74a10.693,10.693,0,0,1-10.705-10.706v-4.282a10.709,10.709,0,0,1,10.705-10.706h344.008A10.709,10.709,0,0,1,3153.453,2357.217Z",
    transform: "translate(9159.901 1452.795)",
    fill: "#2b2ba5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17726",
    "data-name": "Path 17726",
    d: "M3130.615,2348.653v4.282a10.709,10.709,0,0,1-10.706,10.706h-331.66a10.615,10.615,0,0,1-.214-2.141v-4.282a10.709,10.709,0,0,1,10.705-10.706H3130.4A10.591,10.591,0,0,1,3130.615,2348.653Z",
    transform: "translate(9159.901 1452.795)",
    fill: "#3030b5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 429.652,
    height: 294.048,
    rx: 33.545,
    transform: "translate(11211.39 3422.469)",
    fill: "#4332d5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17727",
    "data-name": "Path 17727",
    d: "M1946.55,1724.169v265.186a14.438,14.438,0,0,1-14.431,14.431h-400.79a14.438,14.438,0,0,1-14.431-14.431V1724.169a14.417,14.417,0,0,1,14.431-14.431h400.79a14.428,14.428,0,0,1,14.431,14.431Z",
    transform: "translate(9678.789 1712.731)",
    fill: "#7464ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17728",
    "data-name": "Path 17728",
    d: "M1709.021,2064.305l-25.694,84.218h17.129Z",
    transform: "translate(9610.852 1567.994)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10082",
    "data-name": "Group 10082",
    transform: "translate(11290.071 3632.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17729",
    "data-name": "Path 17729",
    d: "M1976.558,2064.305h47.1l72.8,84.218H1936.59Z",
    transform: "translate(-1782.604 -2064.305)",
    fill: "#3030b5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17730",
    "data-name": "Path 17730",
    d: "M1725.484,2064.3,1696.045,2229.9a23.069,23.069,0,0,0,22.712,27.107h128.057l31.4-192.7Z",
    transform: "translate(-1684.263 -2064.305)",
    fill: "#4332d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17731",
    "data-name": "Path 17731",
    d: "M1706.188,2064.3,1676.749,2229.9a23.069,23.069,0,0,0,22.712,27.107h128.057l31.4-192.7Z",
    transform: "translate(-1676.386 -2064.305)",
    fill: "#2b2ba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17732",
    "data-name": "Path 17732",
    d: "M1926.942,2351.336h115.526c4.782,0,8.659,5.113,8.659,11.419h0c0,6.306-3.877,11.419-8.659,11.419H1926.942Z",
    transform: "translate(-1778.665 -2181.473)",
    fill: "#4332d5"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17733",
    "data-name": "Path 17733",
    d: "M1943.24,1711.094l-60.194,61.45H1564.732s-25.037-44.292-35.557-60.908a14.321,14.321,0,0,1,7.166-1.9h400.79A14.345,14.345,0,0,1,1943.24,1711.094Z",
    transform: "translate(9673.777 1712.731)",
    fill: "#5646e6",
    opacity: 0.55
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10083",
    "data-name": "Group 10083",
    transform: "translate(11302.744 3513.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 194.129,
    height: 11.419,
    rx: 5.71,
    fill: "#d5d1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 194.129,
    height: 11.419,
    rx: 5.71,
    transform: "translate(0 24.266)",
    fill: "#d5d1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 194.129,
    height: 11.419,
    rx: 5.71,
    transform: "translate(0 48.532)",
    fill: "#d5d1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 194.129,
    height: 11.419,
    rx: 5.71,
    transform: "translate(0 71.371)",
    fill: "#d5d1ff"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 125.613,
    height: 159.871,
    transform: "translate(11179.986 3862.113)",
    fill: "#2775f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 1000.619,
    height: 159.871,
    transform: "translate(11305.599 3862.113)",
    fill: "#3888fc"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 1039.405,
    height: 159.871,
    transform: "translate(11304.54 3862.113)",
    fill: "#3888fc"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17734",
    "data-name": "Path 17734",
    d: "M2690,2415.622a25.2,25.2,0,0,1-7.814,18.171,27.194,27.194,0,0,1-18.876,7.522H1432.634c-14.738,0-26.689-11.5-26.689-25.693a25.2,25.2,0,0,1,7.814-18.171,27.194,27.194,0,0,1,18.875-7.522H2663.313C2678.052,2389.929,2690,2401.433,2690,2415.622Z",
    transform: "translate(9724.081 1435.072)",
    fill: "#5598f9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17735",
    "data-name": "Path 17735",
    d: "M2629.21,2389.929a25.2,25.2,0,0,1-7.814,18.171,27.194,27.194,0,0,1-18.875,7.522H1405.945a25.2,25.2,0,0,1,7.814-18.171,27.194,27.194,0,0,1,18.875-7.522Z",
    transform: "translate(9724.081 1435.072)",
    fill: "#70a3ff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17736",
    "data-name": "Path 17736",
    d: "M1565.816,2389.929v51.386H1429.341c-12.92,0-23.4-11.5-23.4-25.693a26.994,26.994,0,0,1,6.85-18.171,22.376,22.376,0,0,1,16.546-7.522Z",
    transform: "translate(9724.081 1435.072)",
    fill: "#3888fc",
    opacity: 0.6
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17737",
    "data-name": "Path 17737",
    d: "M2335,2348.29s19.838-61.317,88.368-61.317,61.317,30.659,55.907,36.069S2335,2348.29,2335,2348.29Z",
    transform: "translate(9344.833 1477.1)",
    fill: "#ffba94"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17738",
    "data-name": "Path 17738",
    d: "M2537,2347.139v14.154H2406.039v-3.4a37.436,37.436,0,0,1,8.367-10.757c14.737-13.919,44.367-28.31,75.414-28.31,16.765,0,27.822,5.158,34.978,11.072C2534.423,2337.828,2537,2347.139,2537,2347.139Z",
    transform: "translate(9315.834 1464.095)",
    fill: "#2e2eaa"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17739",
    "data-name": "Path 17739",
    d: "M2531.765,2332.984h0a14.155,14.155,0,0,1-14.155,14.155h-97.432c14.737-13.919,44.367-28.31,75.414-28.31,16.765,0,27.822,5.158,34.978,11.072A23.826,23.826,0,0,1,2531.765,2332.984Z",
    transform: "translate(9310.063 1464.095)",
    fill: "#229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10086",
    "data-name": "Group 10086",
    transform: "translate(11809.521 3806.953)",
    opacity: 0.47,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17740",
    "data-name": "Path 17740",
    d: "M3055.333,2371.34c9.834-7.046,20.576,2.982,21.032,13.476.477,11-6.254,21.511-13.868,28.687-16.733,15.77-42.78,16.805-64.277,18.533-47.709,3.836-95.633-5.557-143.186.265-19.985,2.446-39.651,7.611-57.421,17.445-17.615,9.748-33,23.812-51.735,31.448-15.637,6.374-34.9,7.425-51.537,5.422a111.023,111.023,0,0,1-51.271-19.933c-18.506-13.415-29.883-32.192-39.678-52.619-9-18.778-21.26-39.021-43.325-42.547-5.941-.949-8.5,8.315-2.509,9.272,25.527,4.078,33.986,32.186,44.6,52.278a121.182,121.182,0,0,0,39.749,44.407c30.785,20.362,75.676,26.689,109.838,11.569,20.192-8.937,36.7-24.406,56.52-34.054,23.1-11.244,49.2-14.5,74.53-14.846,52.539-.712,106.546,9.1,158.323-4.664,21.014-5.585,41.881-22.462,44.432-45.8,1.072-9.8-1.968-19.74-10.046-25.626-7.411-5.4-17.293-6.495-24.933-1.021-4.93,3.533-.22,11.873,4.763,8.3Z",
    transform: "translate(-2554.142 -2359.433)",
    fill: "#a0a0a0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10087",
    "data-name": "Group 10087",
    transform: "translate(11812.665 3803.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17741",
    "data-name": "Path 17741",
    d: "M3060.648,2365.8c9.834-6.916,20.576,2.927,21.032,13.227.477,10.794-6.253,21.112-13.868,28.154-16.733,15.477-42.78,16.493-64.276,18.188-47.71,3.764-95.633-5.453-143.187.261-19.985,2.4-39.651,7.47-57.42,17.121-17.615,9.567-33,23.369-51.736,30.864-15.637,6.256-34.9,7.288-51.536,5.321a112.242,112.242,0,0,1-51.272-19.562c-18.506-13.166-29.883-31.594-39.678-51.642-9-18.429-21.26-38.3-43.325-41.756-5.941-.932-8.5,8.16-2.509,9.1,25.527,4,33.986,31.588,44.6,51.308a119.72,119.72,0,0,0,39.75,43.582c30.784,19.984,75.676,26.194,109.838,11.354,20.192-8.771,36.7-23.953,56.52-33.421,23.1-11.036,49.2-14.233,74.531-14.57,52.539-.7,106.546,8.927,158.323-4.578,21.014-5.482,41.881-22.045,44.432-44.944,1.072-9.623-1.969-19.374-10.047-25.151-7.411-5.3-17.293-6.374-24.933-1-4.93,3.467-.22,11.652,4.763,8.148Z",
    transform: "translate(-2559.457 -2354.117)",
    fill: "#229"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17742",
    "data-name": "Path 17742",
    d: "M2476.155,2316.969s3.539,10.165-9.829,19.237-88.86,23.227-88.86,23.227H2335S2420.716,2301.241,2476.155,2316.969Z",
    transform: "translate(9344.833 1465.956)",
    fill: "#ffba94"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 11.542,
    height: 23.083,
    transform: "translate(11314.366 3143.382) rotate(177)",
    fill: "#7e8a9c"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17746",
    "data-name": "Path 17746",
    d: "M0,14.391s25.226-10.5,44.572-10.5a57.831,57.831,0,0,1,32.813,10.5V9.554S65.61,0,46.263,0,0,9.554,0,9.554Z",
    transform: "matrix(-0.574, -0.819, 0.819, -0.574, 11353.192, 3273.1)",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17747",
    "data-name": "Path 17747",
    d: "M36.565,23.728l4.2-11.309A111.6,111.6,0,0,0,27.113,5.484C19.858,2.471,18.142,1.765,14.364.858S1.774-1.788.206,5.484s6.332,9.649,6.332,9.649S14.05,16.8,21.556,18.954,36.565,23.728,36.565,23.728Z",
    transform: "matrix(-0.998, -0.07, 0.07, -0.998, 11397.058, 3284.703)",
    fill: "#5b5682"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M39.4,80.013c20.8.921,39.311-18.859,37.883-39.656S59.172,1.5,40,.087-1.353,14.684.065,35.5,18.6,79.092,39.4,80.013Z",
    transform: "matrix(0.934, 0.358, -0.358, 0.934, 11288.409, 3130.577)",
    fill: "#bac7db"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M37.386,75.462C56.563,76.88,70.959,61.155,69.542,40.341S51.428,1.506,32.252.089-1.321,14.392.1,35.206,18.21,74.045,37.386,75.462Z",
    transform: "matrix(0.934, 0.358, -0.358, 0.934, 11284.943, 3134.577)",
    fill: "#d3deef"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M23.952,48.347c12.286.907,21.511-9.166,20.6-22.5S32.952.964,20.662.057-.848,9.222.062,22.543,11.666,47.44,23.952,48.347Z",
    transform: "matrix(0.934, 0.358, -0.358, 0.934, 11291.759, 3151.73)",
    fill: "#97a6bc"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M728.791,2222.3s-18.1-16.481-53.608-14.8-72.1,34.565-74.462,68.487,7.341,37.284,13.866,39.015,17.89-5.746,17.321-19.356c.624-13.486.345-43.17,25.432-64.261s75.149-6.344,75.149-6.344Z",
    transform: "translate(10690.871 810.168)",
    fill: "#bac7db"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    transform: "translate(12046.992 2957.543)",
    fill: "#ff4f78",
    stroke: "#df4a77",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 146.5,
    r: 146.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 146.5,
    r: 144.5,
    fill: "none"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 29,
    height: 132,
    rx: 14.5,
    transform: "translate(12178.992 3012.543)",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 14.5,
    cy: 15,
    rx: 14.5,
    ry: 15,
    transform: "translate(12178.992 3166.543)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIllustration);
export default __webpack_public_path__ + "static/media/error-illustration.bd7f09a3.svg";
export { ForwardRef as ReactComponent };